export enum PasswordValidationResults {
  OK,
  BOTH_DIFFERENTS,
  NOT_MATCHING,
}

export const passwordValidation = (password1: string, password2: string) => {
  const Reg = new RegExp(
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{12,}$/,
  );

  if (password1 != password2) {
    return PasswordValidationResults.BOTH_DIFFERENTS;
  }
  if (Reg.test(password1)) {
    return PasswordValidationResults.OK;
  } else {
    return PasswordValidationResults.NOT_MATCHING;
  }
};
